import { Button, Divider } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DELETE, PUT, taskDropDownProps } from 'utils';
import NESTEDROUTE from 'utils/router';
const TaskDropdown = (props: taskDropDownProps) => {
  const navigate = useNavigate();

  const location = useLocation();

  const onSubmit = (id: number) => {
    const url = '/api/absence_request/my_managed/' + id + '/approval/';

    PUT(url, { status: 'approved' }).then(async (res) => {
      if (res.status <= 204) {
        props.refetchCount();
        props.refetch();
        if (location.state.id === id)
          navigate(NESTEDROUTE.request_approval_detail, {
            state: { id: id },
            replace: true,
          });
        props.isOpen();
      }
    });
  };
  const onDelete = (id: number) => {
    const url = `/api/main_task/delete/?ids=${id}`;
    DELETE(url).then((res) => {
      if (res.status === 200) {
        props.refetchCount();
        props.refetch();
      }
    });
  };
  return (
    <div
      style={{
        width: 'fit-content',
        padding: 0,
        marginTop: 2,
      }}
      className={'layout_header_menu_dropdown'}
    >
      <div
        className={'layout_header_menu_dropdown_wrapper'}
        style={{ borderBottom: '1px solid #75ACFF', padding: '16px' }}
      >
        <div
          style={{ fontWeight: 600, fontSize: '14px', color: '#000000' }}
          className={'layout_header_menu_dropdown_menu'}
        >
          My Tasks
        </div>
        <Button
          onClick={props.isOpen}
          icon={
            <img
              src="/icons/close.svg"
              alt="close-icon"
              height={20}
              width={20}
            />
          }
          type="text"
        />
      </div>
      {/* <Divider
        style={{ marginTop: '0px', marginBottom: '0px', color: '#75ACFF' }}
        orientation="left"
      /> */}
      <div
        style={{
          width: '400px',
          padding: '0px',
          maxHeight: '517px',
          overflowY: 'auto',
        }}
        onScroll={(e: React.UIEvent<HTMLDivElement>) => {
          const { scrollHeight, clientHeight, scrollTop } = e.currentTarget;
          const toBottom = clientHeight + scrollTop >= scrollHeight;
          if (toBottom) {
            props.loadMore();
          }
        }}
      >
        {props?.noti?.length !== 0 ? (
          <div>
            {' '}
            {props?.noti?.map((item: any, index: number) => (
              <div
                key={index}
                style={{
                  background: item?.status !== 'todo' ? '#FFFFFF' : '#D2DEFF',
                }}
              >
                <div className={'layout_header_task_dropdown_item'}>
                  <div
                    style={{ display: 'flex', gap: '8px', alignItems: 'none' }}
                  >
                    {item?.status === 'todo' && (
                      <img
                        alt="status"
                        src="/icons/status.svg"
                        style={{
                          marginLeft: -10,
                          marginTop: -26,
                          marginRight: -3,
                        }}
                      />
                    )}
                    <img
                      alt="receive"
                      width={28}
                      height={28}
                      style={{ marginTop: -26 }}
                      src={'/icons/Message1.svg'}
                      onClick={() => {
                        navigate(NESTEDROUTE.request_approval_detail, {
                          state: { id: item?.data?.id },
                          replace: true,
                        });
                        props.isOpen();
                      }}
                    />
                    <div
                      style={
                        item?.status !== 'todo'
                          ? { color: '#6F6F6F' }
                          : { color: '#000000' }
                      }
                      onClick={() => {
                        // navigate('/training', { state: { id: item?.data?.id } });
                        navigate(NESTEDROUTE.request_approval_detail, {
                          replace: true,
                          state: { id: item?.data?.id },
                        });
                        props.isOpen();
                      }}
                    >
                      <div
                        style={{
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                        }}
                      >
                        <span style={{ fontWeight: 700 }}>
                          {item?.data?.user?.first_name}{' '}
                          {item?.data?.user?.last_name}{' '}
                        </span>
                        {item?.data?.status === 'to_be_approved' ? (
                          <span>
                            <span style={{ fontWeight: 400 }}>
                              submitted a leave request for{' '}
                            </span>
                            <span style={{ fontWeight: 600 }}>
                              {dayjs(item?.data?.start_date).format('dddd')},{' '}
                              {dayjs(item?.data?.start_date).date()}
                              {'th '}
                              {dayjs(item?.data?.start_date).format(
                                'MMMM YYYY',
                              )}
                            </span>
                            .
                          </span>
                        ) : (
                          <span>
                            <span style={{ fontWeight: 400 }}>
                              submitted a leave request for{' '}
                            </span>
                            <span style={{ fontWeight: 600 }}>
                              {dayjs(item?.data?.start_date).format('dddd')},{' '}
                              {dayjs(item?.data?.start_date).date()}
                              {'th '}
                              {dayjs(item?.data?.start_date).format(
                                'MMMM YYYY',
                              )}
                            </span>
                            .
                          </span>
                        )}
                      </div>
                      <div
                        style={{
                          color:
                            item?.status === 'todo' ? '#407FDD' : '#6F6F6F',
                          marginTop: 6,
                        }}
                      >
                        {' '}
                        {typeof item.time === 'number'
                          ? `${item.time} days ago`
                          : item.time === '00:00'
                            ? 'now'
                            : item.time.startsWith('00')
                              ? `${item.time.slice(3)} minutes ago`
                              : `${item.time} hours ago`}{' '}
                      </div>
                    </div>
                    <img
                      onClick={() => onDelete(item.id)}
                      style={{ marginTop: -24 }}
                      alt="delete"
                      src="/icons/delete.svg"
                    />
                  </div>
                </div>
                <div
                  style={{ color: 'rgba(63, 127, 222, 1)', marginLeft: '70px' }}
                >
                  {item.created}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                    marginLeft: 53,
                    marginTop: -8,
                  }}
                >
                  <button
                    onClick={() => {
                      // navigate('/training', { state: { id: item?.data?.id } });
                      navigate(NESTEDROUTE.request_approval_detail, {
                        state: { id: item?.data?.id },
                        replace: true,
                      });
                      props.isOpen();
                    }}
                    style={{
                      width: '73px',
                      marginBottom: 14,
                      height: '36px',
                      background: '#FFFFFF',
                      border: item?.status === 'todo' ? 'none' : '1px solid',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      color: '#0E3063',
                    }}
                  >
                    Open
                  </button>
                  {item?.status === 'todo' && (
                    <button
                      onClick={() => onSubmit(item?.data?.id)}
                      style={{
                        width: '73px',
                        height: '36px',
                        border: 'none',
                        borderRadius: '5px',
                        background: '#B0FFA9',
                        cursor: 'pointer',
                        color: '#0E3063',
                        marginBottom: 14,
                      }}
                    >
                      Approve
                    </button>
                  )}
                </div>
                <Divider
                  style={{
                    marginTop: '0px',
                    marginBottom: '0px',
                    background: 'white',
                  }}
                  orientation="left"
                />
              </div>
            ))}
          </div>
        ) : (
          <div>
            <img
              style={{ top: '55px' }}
              src="/icons/empty_task.svg"
              alt="icon"
              className="image is-96x96 is-flex is-justify-content-center is-align-content-center m-auto is-relative "
            />
            <div
              className="is-overlay  has-text-centered"
              style={{ top: '55%', marginLeft: 12 }}
            >
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#000000',
                  marginBottom: 8,
                }}
              >
                No task today
              </p>
              <p style={{ fontSize: 12, fontWeight: 400, color: '#000000' }}>
                You can relax, you haven’t forgotten any info!
              </p>
            </div>
            <img src="/icons/empty_footer.png" alt="icon" width={'100%'} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskDropdown;
